/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Table,
  Select,
  AutoComplete,
  Input,
  // Spin,
  Space,
  Button,
  Modal,
  Tooltip,
  Drawer,
  Typography,
  Image,
  DatePicker,
  TimePicker,
  Switch
  //Card,
  //  Radio,
  // Select,
  // Collapse,
  // Button,
} from "antd";
//import "../index.css";
import {
  CloseOutlined,
  DeleteOutlined,
  //  DownloadOutlined,

  ExclamationCircleOutlined,
  PlusOutlined,
  //UpOutlined,
} from "@ant-design/icons";
import { CloudUploadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
//import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import api from "../../../helpers";
import toast from "react-hot-toast";
import { FaRegEdit } from "react-icons/fa";
import * as action from "../../../store/Notification/actions";
import { loadManageOrganizationList } from "../../../store/reports/actions";
//import { Collapse, Divider} from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import dayjs from "dayjs";
import LogoIcon from "../../../assets/images/admin-logo-3.png";

const PushNotification = (props) => {
  const dispatch = useDispatch();

  const media = useMedia();
  //Validations
  const simpleValidator = React.useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();
  //initial state values
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [endDateEnabled, setEndDateEnabled] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(action.loadNotifyRecordsMetaData());
    dispatch(loadManageOrganizationList());
    dispatch(action.loadPushNotification());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { manage_organization_list = {} } = useSelector(
    (state) => state.Reports
  );
  // reducer state
  const {
    pushNotification_list = [],
    recordsMetaData = {}
  } = useSelector((state) => state.Notification);
  const states = useSelector((state) => state.Notification);
  console.log(states, "RecordsMetaData")

  console.log(pushNotification_list, "pushNotification_list")
  //dropdown
  const organizationOptions = !isEmpty(manage_organization_list.data) ? manage_organization_list.data
    .filter(f => f.status === 1).map((item) => {
      return {
        label: item.organizationName, value: item._id
      }
    }) : []
  //initial modal data
  const [inAppData, setInAppData] = useState({
    title: "",
    body: "",
    clickAction: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: ""
  })
  //handle on change
  const handleChange = (e) => {
    setInAppData({ ...inAppData, [e.target.name]: e.target.value })
  }
  //options
  const typeOptions = [
    { label: "To All Organization", value: "toAllOrganization" },
    { label: "To Organization", value: "toOrganization" },
    { label: "To Users", value: "toUsers" },
    { label: "To Single Users", value: "toSingleusers" },
  ];

  //dropdown values
  const [type, setType] = useState({ label: "", value: "" });
  const [organization, setOrganization] = useState([]);

  const [role, setRole] = useState([]);
  const [user, setUser] = useState([]);
  console.log(role, "rolex")
  // profile picture initial values
  const [fileNames, setFileNames] = useState("");
  const [imagePreviews, setImagePreviews] = useState([]);
  const selectedValues = role?.map(r => r.label) ?? [];
  const userOptions = (recordsMetaData?.userOptions ?? [])
    .filter(option => selectedValues?.includes(option.roleName));
  console.log(userOptions, "userOptions")

  const [singleUser, setSingleUser] = useState({ label: "", value: "" })
  //pofile picture on change and api functionality
  const handleSinglePhoto = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    setFileNames(fileArray[0].name);

    // Upload
    const uploadPromises = fileArray.map((file) => {
      const formData = new FormData();
      formData.append("file", file);
      return api
        .post("/img/upload", formData)
        .then((res) => {
          if (res?.status === 200 && res?.data?.file) {
            toast.success("Image uploaded successfully!", {
              containerId: "toast-1",
            });
            return {
              url: res.data.file,
              name: res.data.file,
            };
          } else {
            const errorMsg = res?.data?.error?.message || "Upload failed.";
            toast.error(errorMsg, { containerId: "toast-1" });
            return null;
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error?.message || "Upload error occurred.";
          toast.error(errorMsg, { containerId: "toast-1" });
          return null;
        });
    });

    const uploadedImages = await Promise.all(uploadPromises);
    const validUploads = uploadedImages.filter(Boolean);
    setImagePreviews(validUploads);
  };
  const handleRemovePreview = (urlToRemove) => {
    setImagePreviews([]);
    setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };
  //edit functionality
  const editInApp = (data) => {
    setInAppId(data._id);
    setEndDateEnabled(true);
    setInAppData({
      title: data.title,
      body: data.body,
      clickAction: data.clickAction,
      startDate: data.startDate,
      endDate: data.endDate,
      startTime: data.startTime
        ? dayjs(data.startTime, ["h:mm A", "HH:mm"])
        : null,
      endTime: data.endTime
        ? dayjs(data.endTime, ["h:mm A", "HH:mm"])
        : null,
    })
    // ✅ setType
    const selectedType = typeOptions.find((opt) => opt.value === data?.type) || {
      label: data?.type || "",
      value: data?.type || "",
    };
    setType(selectedType);

    // ✅ setOrganization
    // ✅ setOrganization
    if (Array.isArray(data?.organizationIds) && data.organizationIds.length > 0) {
      if (data.organizationIds.length === organizationOptions.length) {
        setOrganization([{ label: "All Organizations", value: "All Organizations" }]);
      } else {
        setOrganization(
          data.organizationIds.map((org) => ({
            label: org.organizationName,
            value: org._id,
          }))
        );
      }
    } else {
      setOrganization([]);
    }

    // ✅ setRole
    if (Array.isArray(data?.userIds) && data.userIds.length > 0) {
      if (data.userIds.length === recordsMetaData?.userOptions?.length) {
        // ✅ All users selected
        setUser([{ label: "All Users", value: "All Users" }]);
      } else {
        // ✅ Map multiple users
        setUser(
          data.userIds.map(user => ({
            label: user.userName,
            value: user._id,
          }))
        );
      }
    } else {
      // ✅ No users
      setUser([]);
    }

    if (
      data?.type === "toSingleusers" &&
      Array.isArray(data?.userIds) &&
      data.userIds.length === 1
    ) {
      setSingleUser({
        label: data.userIds[0].userName || "",
        value: data.userIds[0]._id || "",
      });
    }

    if ((data?.roleId?.length || 0) === (recordsMetaData?.roleOptions?.length || 0)) {
      setRole([{ label: "All Role", value: "All Role" }]);
    } else {
      setRole(
        (data?.roleId ?? []).map(r => ({
          label: r.roleName || "",
          value: r._id || ""
        }))
      );
    }

    setImagePreviews([{
      url: data.image,
      name: data.image
    }]);
    setFileNames(data.image);
  }
  //header columns
  const HeaderData = [
    {
      key: "title",
      title: <p className="font-label text-[13px] font-semibold">Title</p>,
      dataIndex: "title",
      width: 100,
      // fixed: "left",
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      key: "body",
      title: (
        <p className="font-label text-[13px] font-semibold">Body</p>
      ),
      dataIndex: "body",
      width: 130,
    },
    {
      key: "image",
      title: <p className="font-label text-[13px] font-semibold">Image</p>,
      dataIndex: "image",
      width: 130,
      render: (text) =>
        text ? (
          <img
            src={text}
            alt="img"
            style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 6 }}
          />
        ) : (
          <span>No Image</span>
        ),
    },

    {
      key: "clickAction",
      title: <p className="font-label text-[13px] font-semibold">Click Action</p>,
      dataIndex: "clickAction", // make sure your data source uses this key
      width: 130,
      render: (text) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1890ff", textDecoration: "underline" }}
          >
            {text}
          </a>
        ) : (
          <span style={{ color: "gray" }}>--</span>
        ),
    },

    {
      key: "type",
      title: <p className="font-label text-[13px] font-semibold">Type</p>,
      dataIndex: "type", // make sure your dataSource uses "type" not "Type"
      width: 130,
      render: (value) => {
        const option = typeOptions.find((opt) => opt.value === value);
        return option ? option.label : value; // fallback to raw value if not found
      },
    },

    {
      key: "organization",
      title: (
        <p className="font-label text-[13px] font-semibold">Organization</p>
      ),
      dataIndex: "organization",
      width: 130,
    },
    {
      key: "status",
      title: <p className="font-label text-[13px] font-semibold">Status</p>,
      dataIndex: "status",
      width: 80,
    },
    {
      key: "action",
      title: <p className="font-label text-[13px] font-semibold">Action</p>,
      dataIndex: "action",
      width: 70,
    },
  ];

  const [editModal, setEditModal] = useState(false);
  const [inAppId, setInAppId] = useState("");
  const onClose = () => {
    setOpen(false);

  };

  const userRoleDataTable =
    !isEmpty(pushNotification_list) && pushNotification_list.length > 0
      ? pushNotification_list.map((data) => {
        return {
          _id: data._id,
          title: data.title,
          body: data.body,
          image: data.image,
          clickAction: data.clickAction || "--",
          type: data.type,
          organization: !isEmpty(data.organizationIds)
            ? (organizationOptions.length === data.organizationIds.length
              ? "All Organization"
              : data.organizationIds.map(m => m.organizationName).join(","))
            : "",

          action: (
            <div className="flex">
              <Tooltip title={"Edit"} placement="top" className="mr-2">
                <div
                  className={
                    "cursor-pointer rounded-sm bg-[#08a35ae0] px-[8px] py-[6px] hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label font-semibold text-start"
                  }
                  onClick={() => {
                    editInApp(data);
                    setOpen(true);
                    setEditModal(true);
                  }}
                >
                  <FaRegEdit className="text-[14px]" />
                </div>
              </Tooltip>
              <Tooltip title={"Delete"} placement="top">
                <div
                  className={
                    "cursor-pointer rounded-sm bg-[#e74c3c] px-[8px] py-[6px] hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label font-semibold text-start"
                  }
                  onClick={() => {
                    setInAppId(data._id);
                    setConfirmationModal(true);
                  }}
                >
                  <DeleteOutlined className="text-[14px]" />
                </div>
              </Tooltip>
            </div>
          ),
          status: (
            <div
              className={
                data &&
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusCode !== undefined &&
                  data.status[0].statusCode === 1
                  ? "w-[60%] flex justify-center cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label text-start"
                  : "w-[60%] flex justify-center cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label text-start"
              }
            >
              {data &&
                data.status &&
                data.status.length > 0 &&
                data.status[0].statusCode !== undefined &&
                data.status[0].statusCode === 1
                ? "Active"
                : "Inactive"}
            </div>
          ),
        };
      })
      : [];



  // //paginations

  useEffect(() => {
    if (userRoleDataTable && userRoleDataTable.length > 0) {
      setUserRoleRows(userRoleDataTable);
    } else {
      setUserRoleRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushNotification_list]);
  //search , print and download
  const [search, setSearch] = useState("");
  const [userRoleRows, setUserRoleRows] = useState(userRoleDataTable);
  const handleSearch = (event) => {
    const filteredRows = userRoleDataTable.filter(
      (row) =>
        Object.values(row).some((data) =>
          String(data).toLowerCase().includes(event.target.value.toLowerCase())
        )
      // row.productName.toLowerCase().includes(event.target.value.toLowerCase())
    );

    setSearch(event.target.value);
    setUserRoleRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };


  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  //clear form
  const clearForm = (e) => {

    e.preventDefault()
    setEditModal(false);
    setEndDateEnabled(false);
    setInAppData({
      title: "",
      body: "",
      clickAction: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: ""
    });
    setType({ label: "", value: "" });
    setSingleUser({ label: "", value: "" });
    setOrganization([]);
    setRole([]);
    setUser([]);
    setImagePreviews([]);
    setFileNames("");
  }
  //handle Submit
  const [disabled, setDisabled] = useState(false);
  console.log(inAppData, "payload settings")
  console.log(organization, "orgg")
  console.log(role, "rolex")
  console.log(user, "userex")
  // handle submit employee
  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    const orgValue =
      type?.value === "toAllOrganization"
        ? organizationOptions.map((m) => m.value)
        : Array.isArray(organization)
          ? organization.map((item) =>
            typeof item === "string" ? item : item.value
          )
          : [];


    const userValue = user && user?.value === "All Users" ? recordsMetaData.userOptions.map(m => m.value)
      : user.map(u => u.value)
    const singleUserValue = singleUser && singleUser ? [singleUser.value] : ""
    const roleValue =
      role && role.length > 0
        ? role[0].value === "All Role"
          ? (recordsMetaData?.roleOptions ?? []).map(m => m.value)
          : role.map(r => r.value)
        : [];
    console.log(singleUser, "singleUser")
    if (simpleValidator.current.allValid()) {
      let payload = {
        title: inAppData.title,
        body: inAppData.body,
        ...(imagePreviews?.[0]?.url && { image: imagePreviews[0].url }),
        ...(inAppData.clickAction && { clickAction: inAppData.clickAction }),
        ...(type?.value && { type: type.value }),
        ...(!isEmpty(roleValue) && { roleId: roleValue }),
        ...(inAppData.startDate && { startDate: dayjs(inAppData.startDate).toDate().toISOString() }),
        ...(inAppData.endDate && { endDate: dayjs(inAppData.endDate).toDate().toISOString() }),
        ...(inAppData.startTime && { startTime: dayjs(inAppData.startTime, "HH:mm").format("hh:mm A") }),
        ...(inAppData.endTime && { endTime: dayjs(inAppData.endTime, "HH:mm").format("hh:mm A") }),
        ...(!isEmpty(orgValue) && { organizationIds: orgValue }),
        ...(
          type.value === "toSingleusers"
            ? !isEmpty(singleUserValue) && { userIds: singleUserValue }
            : !isEmpty(userValue) && { userIds: userValue }
        ),

        ...(editModal && { id: inAppId }),
      };

      //Push
      if (!editModal) {
        api
          .post("/notify/pushnotification", payload)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              dispatch(action.loadPushNotification());
              toast.success("Push notification added successfully");
            } else {
              toast.warning(response?.data?.msg || "");
            }
            setOpen(false);
            return response.data;
          })
          .catch((err) => {
            const errorMsg =
              err?.response?.data?.message ||
              "An error occurred while adding the Push notification";
            toast.error(errorMsg, { containerId: "toast-1" });
            return Promise.reject(err);
          });
      } else {
        api
          .post(`/notify/updatenotification`, payload)

          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              dispatch(action.loadPushNotification());
              toast.success("Push notification updated successfully");
            } else {
              toast.warning(response?.data?.msg || "");
            }

            setOpen(false);
            return response.data;
          })
          .catch((err) => {
            const errorMsg =
              err?.response?.data?.message ||
              "An error occurred while updating the Push notification";
            toast.error(errorMsg, "error");
            return Promise.reject(err);
          });
      }
      //  setIsEdit(false);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
    }
  };
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Push Notification | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Push Notification
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="w-[100%] mt-2">
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
              windowDimensions.height < 830 &&
              userRoleDataTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                userRoleDataTable.length > 0
                ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                : windowDimensions.height > 700 &&
                  windowDimensions.height < 830 &&
                  userRoleDataTable.length == 0
                  ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                  : windowDimensions.height > 830 &&
                    windowDimensions.height < 1000 &&
                    userRoleDataTable.length == 0
                    ? "mt-[1px] h-[62vh] bg-[#ffffff] rounded-md"
                    : windowDimensions.height >= 1000 && userRoleDataTable.length == 0
                      ? "mt-[1px] h-[73vh] bg-[#ffffff] rounded-md"
                      : windowDimensions.height >= 1000
                        ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
                        : "bg-[#ffffff] h-[72vh] rounded-md"
          }
        >
          <Row className="flex flex-col">
            {/* <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3">
              
            </Col> */}
            <Col md={24} lg={24} sm={24} xs={24} className="mt-5 mb-3">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={24}
                  xs={24}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        minWidth:
                          media === "xxl"
                            ? "185%"
                            : media == "sm" || media == "xs"
                              ? "255%"
                              : "125%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        media === "sm" || media === "xs"
                          ? "w-[59%]"
                          : "w-[100%] lg:w-[65%] md:w-[65%]"
                      }
                    >
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            // border: "1px solid lightgray",
                            fontSize: "11px",
                          }}
                          className="rounded-sm"
                          // bordered={false}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={24} xs={24} className="pr-5">
                  <Row className="flex justify-end">

                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="mt-1 lg:mt-0 md:mt-0"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                  ? "245%"
                                  : "125%",
                            paddingRight: media == "md" ? "20px" : "20px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "10px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={14}
                            xs={14}
                            className="sm:pr-0 pr-3 ml-3 mt-1 lg:mt-0 xl:mt-0 xxl:mt-0 md:mt-0 xl:ml-0 xxl:ml-0 lg:ml-0 md:ml-0"
                          >
                            <div
                              onClick={(e) => {
                                setOpen(true);
                                setEditModal(false);
                                clearForm(e);
                              }}
                              className="sm:flex sm:justify-center bg-[#074179] text-[white] focus:bg-[#1d3b59] cursor-pointer px-4 lg:px-7 xl:px-7 xxl:px-5 md:px-2 py-[6px] flex rounded-md hover:bg-[#1d3b59]"
                            >
                              <PlusOutlined className="mr-1" />
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="text-[14px] text-[white]"
                              >
                                Push Notification
                              </h1>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Drawer
              closable={false} // hide default X icon
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>
                    {editModal ? "Update Push Notification" : "Add Push Notification"}
                  </h1>
                  <Button
                    type="text"
                    onClick={onClose}
                    className="font-label"
                    icon={<CloseOutlined />}
                  />
                </div>
              }
              placement="right"
              onClose={onClose}
              open={open}
              width={"100%"}
              maskClosable={false}
              className="font-label"
              styles={{
                body: {
                  padding: "18px",
                },
                footer: {
                  position: "sticky",
                  bottom: 0,
                  background: "#fff",
                  zIndex: 1,
                },
                content: {
                  transition: "transform 1s ease-in-out", // optional, for smoother feel
                },
              }}
              footer={
                <div style={{ textAlign: "right", padding: "4px" }}>
                  <Space>
                    <Button
                      onClick={onClose}
                      style={{
                        background: "#fff1f0",
                        color: "#ff4d4f",
                        borderColor: "#ffa39e",
                      }}
                      className="font-label"
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={disabled}
                      className="font-label"
                      type="primary"
                      onClick={handleSubmit}
                    >
                      {editModal ? "Update" : "Submit"}
                    </Button>
                  </Space>
                </div>
              }
            >
              <div
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "16px",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    background: "#e6f7ff", // Ant Design's info background
                    color: "#1890ff",      // Ant Design's info text color
                    padding: "10px 16px",
                    fontWeight: 600,
                    fontFamily: "Poppins",

                  }}
                >
                  General Notifications Settings
                </div>

                {/* Body */}
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                  }}
                >
                  <Row gutter={[16, 16]}>
                    {/* Form Section - 18 columns */}
                    <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
                      <Row gutter={[16, 16]}>

                        <Col md={16} sm={24} lg={16} xl={16} xxl={16} xs={24} className="mb-2">
                          <Typography className="font-label text-[13px] mb-2">
                            Title <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                          </Typography>
                          <Input
                            placeholder="Enter Title"
                            value={inAppData.title}
                            name="title"
                            className="font-label mb-2 h-[40px]"
                            onChange={(e) => handleChange(e)}
                          />
                          <span
                            style={{
                              color: "#ef3022",
                              fontSize: "11px",
                              marginTop: "8px",
                              fontFamily: "poppins",
                              display: "block",
                            }}
                          >
                            {simpleValidator.current.message(
                              "title",
                              inAppData.title,
                              "required"
                            )}
                          </span>
                        </Col>
                        <Col md={16} sm={24} lg={16} xl={16} xxl={16} xs={24} className="mb-2">
                          <Typography className="font-label text-[13px] mb-2">
                            Body <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                          </Typography>
                          <Input.TextArea
                            placeholder="Enter Body"
                            value={inAppData.body}
                            name="body"
                            className="font-label mb-2 h-[40px]"
                            onChange={(e) => handleChange(e)}
                            rows={4}
                          />
                          <span
                            style={{
                              color: "#ef3022",
                              fontSize: "11px",
                              marginTop: "8px",
                              fontFamily: "poppins",
                              display: "block",
                            }}
                          >
                            {simpleValidator.current.message("body", inAppData.body, "required")}
                          </span>
                        </Col>
                        <Col md={16} sm={24} lg={16} xl={16} xxl={16} xs={24} className="mb-2">
                          <Typography className="font-label text-[13px] mb-2">Image</Typography>
                          <div style={{ position: "relative", marginTop: 8 }}>
                            <Input
                              value={fileNames}
                              placeholder="Upload Image"
                              readOnly
                              onClick={() =>
                                document.getElementById("gallery-file-upload").click()
                              }
                              prefix={
                                <CloudUploadOutlined
                                  style={{
                                    color: "blue",
                                    fontSize: 24,
                                    marginRight: 12,
                                  }}
                                />
                              }
                              style={{
                                cursor: "pointer",
                                paddingLeft: 8,
                                height: "40px",
                              }}
                            />

                            {/* Hidden file input */}
                            <input
                              id="gallery-file-upload"
                              type="file"
                              accept="image/*"
                              onChange={handleSinglePhoto}
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                opacity: 0,
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                              }}
                            />
                          </div>

                          {/* Image Previews */}
                          {imagePreviews.length > 0 && (
                            <div style={{ marginTop: 16 }}>
                              <Typography.Text type="secondary">Preview:</Typography.Text>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                                  gap: 12,
                                  marginTop: 12,
                                }}
                              >
                                {imagePreviews.map((img, idx) => (
                                  <div key={idx} style={{ position: "relative" }}>
                                    <Image
                                      src={img.url}
                                      width={100}
                                      height={100}
                                      style={{
                                        objectFit: "cover",
                                        borderRadius: 6,
                                      }}
                                      preview={true}
                                    />
                                    <CloseOutlined
                                      onClick={() => handleRemovePreview(img.url)}
                                      style={{
                                        position: "absolute",
                                        top: -8,
                                        right: -8,
                                        background: "#fff",
                                        borderRadius: "50%",
                                        color: "#ef3022",
                                        fontSize: 14,
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                                        cursor: "pointer",
                                        padding: 2,
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </Col>

                        <Col md={16} sm={24} lg={16} xl={16} xxl={16} xs={24} className="mb-2">
                          <Typography className="font-label text-[13px] mb-2">
                            Click Action
                          </Typography>
                          <Input
                            placeholder="Enter Click Action"
                            value={inAppData.clickAction}
                            name="clickAction"
                            className="font-label mb-2 h-[40px]"
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>


                      </Row>
                    </Col>

                    {/* Preview Section - 6 columns */}
                    <Col xs={24} sm={24} md={6} lg={6} xl={6} xxl={6}>
                      <div className="relative mx-auto mt-2 flex h-[560px] w-[360px] items-center justify-center rounded-[2rem] border-[6px] border-black bg-black p-3 shadow-xl">
                        <div className="absolute left-1/2 top-2 h-4 w-20 -translate-x-1/2 rounded-full bg-[#d0d0d0]" />

                        <div className="relative h-full w-full overflow-hidden rounded-xl bg-gradient-to-b from-[#e7ebf0] to-[#d5dbe3] px-4 py-5 text-black">
                          <div className="mb-3 flex items-center gap-1 text-[11px] text-gray-600">
                            <img
                              src="https://www.google.com/favicon.ico"
                              className="h-4 w-4"
                              alt="Chrome"
                            />
                            <span>http://mbookmobile.mequalsvps.in • now</span>
                          </div>

                          <div className="rounded-2xl bg-white p-3 shadow-md">
                            <div className="flex items-start justify-between">
                              <div>
                                <div className="text-sm font-semibold text-gray-900">
                                  {inAppData.title || "Notification Preview"}
                                </div>
                                <div className="text-sm text-gray-600">
                                  {inAppData.body ||
                                    "This is how your push message will appear"}
                                </div>
                              </div>
                              <img
                                src={LogoIcon}
                                alt="App Icon"
                                className="h-6 w-6 rounded-md"
                              />
                            </div>

                            {imagePreviews.length > 0 && (
                              <div className="mt-3 overflow-hidden rounded-lg">
                                <img
                                  src={imagePreviews[0].url}
                                  alt="Attached Visual"
                                  className="h-32 w-full rounded-lg object-cover"
                                />
                              </div>
                            )}

                            <div className="text-blue-600 mt-3 flex gap-6 text-sm font-medium">
                              <button className="hover:underline">Reply</button>
                              <button className="hover:underline">Ignore</button>
                              <button className="hover:underline">Cancel</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

              </div>
              <div
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "16px",
                  marginTop: "20px"
                }}
              >
                {/* Header */}
                <div
                  style={{
                    background: "#e6f7ff", // Ant Design's info background
                    color: "#1890ff",      // Ant Design's info text color
                    padding: "10px 16px",
                    fontWeight: 600,
                    fontFamily: "Poppins",

                  }}
                >
                  Organization Notification Settings
                </div>

                {/* Body */}
                <div
                  style={{
                    background: "#f5f5f5", // Light grey background
                    padding: "16px",
                  }}
                >


                  <Row gutter={16}>
                    <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} className="mb-2">
                      <Typography className="font-label text-[13px] mb-2">Type</Typography>
                      <Select
                        placeholder="Select Type"
                        allowClear
                        style={{ width: "100%" }}
                        value={type.value || undefined}
                        onChange={(value, option) => {
                          if (option) {
                            const newType = { label: option.label, value };
                            setType(newType);

                            if (value === "toAllOrganization") {
                              // auto-set "All Organizations" and disable
                              setOrganization([{ label: "All Organizations", value: "All Organizations" }]);
                              setRole([{ label: "All Role", value: "All Role" }])
                            } else if (value === "toOrganization") {
                              // clear if not organization-related
                              setOrganization([]);
                              setRole([{ label: "All Role", value: "All Role" }])
                            } else if (value === "toSingleusers") {

                              setUser([]);
                              setOrganization([]);
                              setRole([]);

                            } else if (value === "toUsers") {
                              setUser([]);
                              setOrganization([]);
                              setRole([]);
                            }
                          } else {
                            setType({ label: "", value: "" });
                            setOrganization([]);
                            setUser([]);
                            setSingleUser([]);
                          }
                        }}
                        className="font-label h-[40px]"
                        options={typeOptions}
                        autoComplete="off"
                        dropdownRender={(menu) => <h1 className="option-text-font">{menu}</h1>}
                      />

                    </Col>

                    <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} className="mb-2">
                      <Typography className="font-label text-[13px] mb-2">
                        Organization
                      </Typography>

                      <Select
                        mode="multiple"
                        placeholder="Select Organization"
                        allowClear

                        style={{ width: "100%" }}
                        value={organization}  // organization must always be an array of {label, value}
                        onChange={(values) => {
                          setOrganization(values); // values already comes as [{ label, value }, ...]
                        }}
                        //  className="font-label h-[40px]"
                        options={organizationOptions}
                        autoComplete="off"

                        disabled={
                          type?.value === "toAllOrganization"

                        }
                      />

                    </Col>

                    {(type?.value === "toUsers" || type?.value === "toSingleusers" ||
                      type?.value === "toOrganization" || type?.value === "toAllOrganization") && (
                        <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24}>
                          <Typography className="font-label text-[13px] mb-2">
                            Role
                          </Typography>
                          <Select
                            mode="multiple"
                            labelInValue
                            placeholder="Select role"
                            allowClear
                            style={{ width: "100%" }}
                            name="role"
                            value={role}
                            onChange={(values = []) => {
                              // if user selects other roles, drop "All Role"
                              const cleaned = values.filter(v => v.value !== "All Role");

                              // if only "All Role" was selected and nothing else, keep it
                              setRole(cleaned.length > 0 ? cleaned : values);
                              setUser([]);
                              setSingleUser({ label: "", value: "" });
                            }}
                            options={
                              !isEmpty(recordsMetaData.roleOptions)
                                ? recordsMetaData.roleOptions
                                : []
                            }
                            autoComplete="off"
                            dropdownRender={(menu) => (
                              <h1 className="option-text-font">{menu}</h1>
                            )}
                          />

                        </Col>
                      )}
                    {(type?.value === "toSingleusers") && (
                      <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24}>
                        <Typography className="font-label text-[13px] mb-2">
                          User
                        </Typography>
                        <Select
                          placeholder="Select user"
                          allowClear
                          style={{ width: "100%" }}
                          name="singleUser"
                          value={singleUser}
                          onChange={(value, options) => {
                            if (options) {
                              // normal selection
                              setSingleUser({
                                label: options.label,
                                value: value,
                              });

                            } else {
                              // cleared selection
                              setSingleUser({ label: "", value: "" });
                            }
                          }}
                          className="font-label h-[40px]"
                          options={userOptions}
                          autoComplete="off"
                          dropdownRender={(menu) => (
                            <h1 className="option-text-font">{menu}</h1>
                          )}
                        />

                      </Col>
                    )}
                    {(type?.value === "toUsers") && (
                      <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} >
                        <Typography className="font-label text-[13px] mb-2">
                          User
                        </Typography>
                        <Select
                          mode="multiple"
                          labelInValue
                          placeholder="Select user"
                          allowClear
                          style={{ width: "100%" }}
                          name="user"
                          value={user}
                          onChange={(values) => {
                            setUser(values); // values already comes as [{ label, value }, ...]
                          }}

                          options={userOptions}
                          autoComplete="off"
                          dropdownRender={(menu) => (
                            <h1 className="option-text-font">{menu}</h1>
                          )}
                        />

                      </Col>
                    )}
                  </Row>

                </div>
              </div>

              <div
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "16px",
                  marginTop: "20px",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    background: "#e6f7ff",
                    color: "#1890ff",
                    padding: "10px 16px",
                    fontWeight: 600,
                    fontFamily: "Poppins",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>Date</span>
                  <div>
                    <Typography.Text className="mr-2">Enable End Date</Typography.Text>
                    <Switch
                      checked={endDateEnabled}
                      onChange={(checked) => {
                        setEndDateEnabled(checked);
                        if (!checked) {
                          // clear end date/time when disabled
                          setInAppData({
                            ...inAppData,
                            endDate: "",
                            endTime: null,
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                {/* Body */}
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                  }}
                >
                  <Row gutter={16}>
                    {/* Start Date */}
                    <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} className="mb-2">
                      <Typography className="font-label text-[13px] mb-2">
                        Start Date
                      </Typography>
                      <DatePicker
                        format="YYYY-MM-DD"
                        className="w-full h-[40px]"
                        value={inAppData.startDate ? dayjs(inAppData.startDate) : null}
                        onChange={(date, dateString) =>
                          setInAppData({ ...inAppData, startDate: dateString })
                        }
                        disabledDate={(current) =>
                          inAppData.endDate
                            ? current && current > dayjs(inAppData.endDate)
                            : false
                        }
                      />
                    </Col>

                    {/* Start Time */}
                    <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} className="mb-2">
                      <Typography className="font-label text-[13px] mb-2">
                        Start Time
                      </Typography>
                      <TimePicker
                        format="HH:mm"
                        className="w-full h-[40px]"
                        value={inAppData.startTime || null}
                        onChange={(time) =>
                          setInAppData({ ...inAppData, startTime: time })
                        }
                        disabledTime={() => {
                          if (!inAppData.endTime) return {};
                          const end = dayjs(inAppData.endTime, "HH:mm");
                          return {
                            disabledHours: () =>
                              Array.from({ length: 24 }, (_, i) =>
                                i > end.hour() ? i : -1
                              ).filter((x) => x >= 0),
                            disabledMinutes: (h) =>
                              h === end.hour()
                                ? Array.from({ length: 60 }, (_, i) =>
                                  i > end.minute() ? i : -1
                                ).filter((x) => x >= 0)
                                : [],
                          };
                        }}
                      />
                    </Col>
                  </Row>

                  {endDateEnabled && (
                    <Row gutter={16}>

                      {/* End Date */}
                      <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} className="mb-2">
                        <Typography className="font-label text-[13px] mb-2">
                          End Date
                        </Typography>
                        <DatePicker
                          format="YYYY-MM-DD"
                          className="w-full h-[40px]"
                          value={inAppData.endDate ? dayjs(inAppData.endDate) : null}
                          onChange={(date, dateString) =>
                            setInAppData({ ...inAppData, endDate: dateString })
                          }
                          disabledDate={(current) =>
                            inAppData.startDate ? current && current < dayjs(inAppData.startDate) : false
                          }
                        />
                      </Col>

                      {/* End Time */}
                      <Col md={8} sm={24} lg={8} xl={8} xxl={8} xs={24} className="mb-2">
                        <Typography className="font-label text-[13px] mb-2">
                          End Time
                        </Typography>
                        <TimePicker
                          format="HH:mm"
                          className="w-full h-[40px]"
                          value={inAppData.endTime || null}
                          onChange={(time) =>
                            setInAppData({ ...inAppData, endTime: time })
                          }
                          disabledTime={() => {
                            if (!inAppData.startTime) return {};
                            const start = dayjs(inAppData.startTime, "HH:mm");
                            return {
                              disabledHours: () =>
                                Array.from({ length: 24 }, (_, i) => (i < start.hour() ? i : -1)).filter(
                                  (x) => x >= 0
                                ),
                              disabledMinutes: (h) =>
                                h === start.hour()
                                  ? Array.from({ length: 60 }, (_, i) => (i < start.minute() ? i : -1)).filter(
                                    (x) => x >= 0
                                  )
                                  : [],
                            };
                          }}
                        />
                      </Col>


                    </Row>
                  )}

                </div>
              </div>
            </Drawer>

            <Col
              span={24}
              className={media === "xxl" ? "pt-2 pl-4 pb-4" : "pr-1 pl-4 pb-4"}
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  userRoleRows &&
                    userRoleRows.length > 0 &&
                    !isEmpty(userRoleRows[0]._id)
                    ? userRoleRows
                    : []
                }
                rowClassName={"table-row-label p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  // onChange: (page, pageSize) =>
                  //   handlePagination(page, pageSize),
                  // page
                  total: !isEmpty(search)
                    ? userRoleRows.length
                    : pushNotification_list && pushNotification_list
                      ? pushNotification_list.total
                      : "",
                  showTotal: (total, pageSize) => {
                    const indexOfLastRow =
                      pageSize && pageSize.length > 0 && pageSize[1];
                    const indexOfFirstRow =
                      pageSize && pageSize.length > 0 && pageSize[0];

                    return (
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                        }}
                      >
                        Showing rows {indexOfFirstRow} to {indexOfLastRow} of{" "}
                        {!isEmpty(search)
                          ? userRoleRows.length
                          : pushNotification_list &&
                            pushNotification_list.pagination
                            ? pushNotification_list.pagination.total
                            : total}
                      </p>
                    );
                  },
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{ x: 825 }}
              />
            </Col>
          </Row>
        </Col>
        <Modal
          open={confirmationModal}
          onOk={() => {
            api
              .post("/notify/deletenotification", {
                id: inAppId,
              })
              .then((res) => {
                toast.success(`${"Push notification deleted successfully"}`);
                dispatch(action.loadPushNotification());
                return res.data;
              })
              .catch((error) => {
                const errorMsg =
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.error) ||
                  (error && error.message);

                toast.error(errorMsg || "There is an issue while login");
                Promise.reject(error);
              });
            setConfirmationModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Confirm"}
          cancelText={"Cancel"}
          okType="danger"
          // okButtonProps={{
          //   disabled: isButtonDisabled ? true : false,
          // }}
          onCancel={() => setConfirmationModal(false)}
          height={300}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-3">
                <OkBtn />
              </div>
            </div>
          )}
        >
          <div className="text-center w-[100%] p-7">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="font-label text-center text-[16px] font-bold">
              Are you sure you want to delete the Push notification?
            </h1>
          </div>
        </Modal>
      </Row>
    </React.Fragment>
  );
};

PushNotification.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};
//PushNotification
export default PushNotification;
